import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

import { LocalityInput, TextInput } from "@/components/atoms";
import { RefSelectInput } from "@/components/molecules";
import { AddressMaxLength } from "@/validations/address";

import { CustomerCardFormType } from "../../../../formType";

const AddressFields: FC = () => {
    const { t } = useTranslation();
    const { control } = useFormContext<CustomerCardFormType>();

    return (
        <>
            <Grid item xs={12}>
                <TextInput
                    name="personal.street"
                    label={t("Common.Street")}
                    required
                    autoComplete="off"
                    maxLength={AddressMaxLength.Street}
                    control={control}
                />
            </Grid>
            <Grid item xs={6}>
                <TextInput
                    name="personal.houseNumber"
                    label={t("Common.Number")}
                    required
                    autoComplete="off"
                    maxLength={AddressMaxLength.HouseNumber}
                    control={control}
                />
            </Grid>
            <Grid item xs={6}>
                <TextInput
                    name="personal.boxNumber"
                    label={t("Common.Box")}
                    autoComplete="off"
                    maxLength={AddressMaxLength.BoxNumber}
                    control={control}
                />
            </Grid>
            <Grid item xs={6}>
                <TextInput
                    name="personal.zipCode"
                    label={t("Common.PostalCode")}
                    required
                    autoComplete="off"
                    maxLength={AddressMaxLength.ZipCode}
                    control={control}
                />
            </Grid>
            <Grid item xs={6}>
                <LocalityInput
                    name="personal.city"
                    postalCode="personal.zipCode"
                    country="personal.country"
                    control={control}
                    required
                />
            </Grid>
            <Grid item xs={12}>
                <TextInput
                    name="personal.additionalInfo"
                    maxLength={AddressMaxLength.AdditionalAddress}
                    label={t("Common.AdditionalAddress")}
                    autoComplete="off"
                    control={control}
                />
            </Grid>
            <Grid item xs={12}>
                <RefSelectInput name="personal.country.id" required table="country" control={control} />
            </Grid>
        </>
    );
};

export default AddressFields;
